/* eslint-disable security/detect-object-injection */
import { flexRender } from '@tanstack/react-table';
import React from 'react';
import { LXS_BILLING_DOCUMENTS_TABLE_DOCUMENT_ID } from '../../../configuration/billing-documents';
import DocumentDownloadItem from '../../../utilities/document-download-item';
import { IBillingDocumentsTable } from '../lxs-billing-documents.data';

const BillingDocumentsTableBody: React.FC<IBillingDocumentsTable> = ({ table, CLASS_NAME, resources, context }) => {
    return (
        <tbody key={table.getState().pagination.pageIndex} className='fade-slide-right'>
            {table.getRowModel().rows.length === 0 ? (
                <td colSpan={table.getAllColumns().length} className='no-padding'>
                    <div className='alert alert-info' role='alert'>
                        {resources.lxsBillingDocumentsNoDocumentsForFilterFound}
                    </div>
                </td>
            ) : (
                table.getRowModel().rows.map((row, index) => {
                    const isEven = index % 2 === 1;
                    const rowClass = `parent ${isEven ? 'even-parent' : 'odd-parent'}`;
                    return (
                        <React.Fragment key={row.id}>
                            <tr className={rowClass}>
                                {row.getVisibleCells().map(cell => {
                                    if (cell.column.id === LXS_BILLING_DOCUMENTS_TABLE_DOCUMENT_ID) {
                                        return (
                                            <>
                                                <td key={cell.id}>
                                                    <DocumentDownloadItem
                                                        context={context}
                                                        resources={resources}
                                                        documentItem={row.original}
                                                    />
                                                </td>
                                            </>
                                        );
                                    } else {
                                        return (
                                            <>
                                                <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
                                            </>
                                        );
                                    }
                                })}
                            </tr>
                        </React.Fragment>
                    );
                })
            )}
        </tbody>
    );
};

export default BillingDocumentsTableBody;
